import { initYoutubeLazyEmbeds } from "./modules/youtube-lazy-embed.js";

initYoutubeLazyEmbeds();
